import { h } from "vue";
import type { IconSet, IconProps } from "vuetify";

// Left menu icons
import iconMenuDomovInactive from "./icons/icon-menu-home-inactive.vue";
import iconMenuDomovActive from "./icons/icon-menu-home-active.vue";
import iconMenuPogodbeInactive from "./icons/icon-menu-user-contract-list-inactive.vue";
import iconMenuPogodbeActive from "./icons/icon-menu-user-contract-list-active.vue";
import iconMenuPredracunInactive from "./icons/icon-menu-pro-forma-inactive.vue";
import iconMenuPredracunActive from "./icons/icon-menu-pro-forma-active.vue";
import iconMenuIzracunObrokaInactive from "./icons/icon-menu-installment-plan-calc-inactive.vue";
import iconMenuIzracunObrokaActive from "./icons/icon-menu-installment-plan-calc-active.vue";

// App bar icons
import iconAppBarInformacijeActive from "./icons/icon-app-bar-information-active.vue";
import iconAppBarInformacijeInactive from "./icons/icon-app-bar-information-inactive.vue";
import iconAppBarContactActive from "./icons/icon-app-bar-contact-active.vue";
import iconAppBarContactInactive from "./icons/icon-app-bar-contact-inactive.vue";
import iconAppBarFaqActive from "./icons/icon-app-bar-faq-active.vue";
import iconAppBarFaqInactive from "./icons/icon-app-bar-faq-inactive.vue";
import iconAppBarConditionsActive from "./icons/icon-app-bar-conditions-active.vue";
import iconAppBarConditionsInactive from "./icons/icon-app-bar-conditions-inactive.vue";

// Password show/hide icons
import iconPasswordVisible from "./icons/icon-password-visible.vue";
import iconPasswordNotVisible from "./icons/icon-password-not-visible.vue";

//
import iconVerificationEmail from "./icons/icon-verification-email.vue";


const customSvgNameToComponent: any = {
  iconMenuDomovInactive,
  iconMenuDomovActive,
  iconMenuPogodbeInactive,
  iconMenuPogodbeActive,
  iconMenuPredracunInactive,
  iconMenuPredracunActive,
  iconMenuIzracunObrokaInactive,
  iconMenuIzracunObrokaActive,

  iconAppBarInformacijeActive,
  iconAppBarInformacijeInactive,
  iconAppBarContactActive,
  iconAppBarContactInactive,
  iconAppBarFaqActive,
  iconAppBarFaqInactive,
  iconAppBarConditionsActive,
  iconAppBarConditionsInactive,

  iconPasswordVisible,
  iconPasswordNotVisible,

  iconVerificationEmail
};

type IconSet = typeof IconSet;
type IconProps = typeof IconProps;

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon]),
  // component: (props: IconProps) => h(props.tag, [h(customSvgNameToComponent[props.icon as string], { class: 'v-icon__svg' })]),
};

export { customSVGs /* aliases */ };